import {Role} from './role';

export class PersonneContact {
    enfant: Role = new Role();
    parent: Role = new Role();
    psc_fonction: string;
    psc_id:  string;
    psc_role_enfant: string;
    psc_role_parent: string;

    constructor(init?: Partial<PersonneContact>) {
        Object.assign(this, init);

        if (!init)
            return;
        this.parent = init['parent'] ? new Role(init['parent']) : new Role();
        this.enfant = init['enfant'] ? new Role(init['enfant']) : new Role();
    }
}
